/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { MdExpandMore } from "react-icons/md";
import { HiOutlineX } from "react-icons/hi";

const useStyles = makeStyles(() => ({
  collapseContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.3)",
    backgroundColor: "#ffffff",
    padding: "20px",
    width: "100%",
  },
  nestedCollapse: {
    backgroundColor: "#fcfcfc",
  },
  collapseLabel: {
    display: "flex",
    gap: "5px",
    width: "100%",
    height: "100%",
    justifyContent: "space-between",
  },
  labelContainer: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    fontWeight: "500",
    cursor: "pointer",
    userSelect: "none",
  },
  deleteButton: { cursor: "pointer", userSelect: "none" },
}));

const CompetitorCollapseRow = ({
  isNested = false,
  label,
  isCollapsed = false,
  children,
  onDeleteRow = () => {},
}) => {
  const classes = useStyles();
  const [isLocalCollapsed, setIsLocalCollapsed] = useState(isCollapsed);

  const handleRowColapse = () => {
    setIsLocalCollapsed(!isLocalCollapsed);
  };

  return (
    <Box
      className={`${classes.collapseContainer} ${isNested &&
        classes.nestedCollapse}`}
    >
      <Box className={classes.collapseLabel}>
        <Box className={classes.labelContainer} onClick={handleRowColapse}>
          <MdExpandMore size={24} />
          {label}
        </Box>
        {isNested && (
          <Box className={classes.deleteButton} onClick={onDeleteRow}>
            <HiOutlineX size={24} />
          </Box>
        )}
      </Box>
      {!isLocalCollapsed && children}
    </Box>
  );
};

export default CompetitorCollapseRow;
